import { useHistory, useLocation } from "react-router-dom";

import { Link } from "common/types/routing";

import { removeUndefinedKeys } from "seneca-common/utils/functions";
import { logSignUpEventByAccountType } from "seneca-common/utils/senecaAnalytics";

import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import { linkToDashboard } from "features/dashboard/links";
import { linkToParentDashboard } from "features/parents/links";
import { useIsPlurallApp } from "features/plurall";
import { userAccountType } from "features/user/consts";

import SignUpFormAccountType from "../sign-up-form/components/SignUpFormAccountType";

type Props = {
  pageNumber: number;
  totalNumberOfPages: number;
  linkToSignUpStudentDetails: string;
  linkToSignUpTeacherDetails: string;
  search: string;
};

export default function SignUpAccountType({
  pageNumber,
  totalNumberOfPages,
  linkToSignUpStudentDetails,
  linkToSignUpTeacherDetails,
  search
}: Props) {
  const history = useHistory();
  const location = useLocation();
  const isPlurall = useIsPlurallApp();

  const navigateTo = (link: Link) => () => {
    const linkIsString = typeof link === "string";
    // @ts-ignore
    const pathname = linkIsString ? link : link.pathname;
    // @ts-ignore
    const linkState = linkIsString ? {} : removeUndefinedKeys(link.state);
    const locationState = removeUndefinedKeys(location.state);

    history.push(
      makeInternalRedirectState({
        pathname,
        state: { ...locationState, ...linkState }
      } as any)
    );
  };

  const navigateToParentDashboard = () =>
    history.push(linkToParentDashboard() + search);

  const navigateToStudentDashboard = () =>
    history.push(linkToDashboard() + search);

  const onParentSignUpComplete = () => {
    logSignUpEventByAccountType(userAccountType.schoolparent);
    navigateToParentDashboard();
  };

  const onStudentSignUpComplete = () => {
    logSignUpEventByAccountType(userAccountType.schoolstudent);
    navigateToStudentDashboard();
  };

  return (
    <SignUpFormAccountType
      pageNumber={pageNumber}
      totalNumberOfPages={totalNumberOfPages}
      onStudentClick={
        isPlurall
          ? onStudentSignUpComplete
          : navigateTo(linkToSignUpStudentDetails)
      }
      onTeacherClick={navigateTo(linkToSignUpTeacherDetails)}
      onParentClick={onParentSignUpComplete}
    />
  );
}
